export const paginate = {
  pagination: {
    currentPage: 1,
    totalRecords: 0,
    recordsPerPage: 10,
    totalNumberOfPages: 0,
    maxDisplayPages: 5,
    elementId: '',
  },
  pages: [],

  setCurrentPage(pageNumber) {
    this.pagination.currentPage = pageNumber;
    this.createPageElement();
  },

  getCurrentPage() {
    return +this.pagination.currentPage;
  },

  setTotalRecords(totalRecords, page) {
    this.pagination.totalRecords = totalRecords;
    this.reset(page);
  },

  getTotalRecords() {
    return +this.pagination.totalRecords;
  },

  setRecordsPerPage(recordsPerPage) {
    this.pagination.recordsPerPage = recordsPerPage;
    this.reset();
  },

  getRecordsPerPage() {
    return +this.pagination.recordsPerPage;
  },

  previous() {
    if (this.getCurrentPage() - 1 > 0) {
      this.setCurrentPage(this.getCurrentPage() - 1);
    } else {
      this.setCurrentPage(1);
    }
    this.createPageElement();
  },

  next() {
    if (this.getCurrentPage() + 1 < this.getLastPage()) {
      this.setCurrentPage(this.getCurrentPage() + 1);
    } else {
      this.setCurrentPage(this.getLastPage());
    }
    this.createPageElement();
  },

  reset(page = 1) {
    this.setCurrentPage(page);
    this.createPageElement();
  },

  getLastPage() {
    if (this.pagination.totalRecords < 1) {
      return 1;
    }
    return Math.ceil(this.pagination.totalRecords / this.pagination.recordsPerPage);
  },

  isFirstPage() {
    return this.getCurrentPage() === 1;
  },

  isLastPage() {
    return this.getLastPage() === this.getCurrentPage();
  },

  getTotalItems() {
    return +this.pagination.totalRecords;
  },

  calculatePageNumber(i, currentPage, paginationRange, totalPages) {
    const halfWay = Math.ceil(paginationRange / 2);
    if (i === paginationRange) {
      if (currentPage - halfWay + i < i) {
        return i;
      }
      if (currentPage - halfWay + i > totalPages) {
        return totalPages;
      }
      return currentPage - halfWay + i;
    }
    if (paginationRange < totalPages) {
      if (totalPages - halfWay < currentPage) {
        return totalPages - paginationRange + i;
      }
      if (halfWay < currentPage) {
        return currentPage - halfWay + i;
      }
      return i;
    }
    return i;
  },
};
